/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT Decoder`)
};

const es_jw_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT Decoder`)
};

const de_jw_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT-Decoder`)
};

const nl_jw_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT Decoder`)
};

const fr_jw_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décodeur JWT`)
};

const it_jw_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT Decoder`)
};

const pt_br2_jw_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT Decoder`)
};

const pt_jw_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descodificador JWT`)
};

const ja_jw_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT デコーダー`)
};

const zh_jw_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT 解码器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_tool_name", locale)
	if (locale === "en") return en_jw_tool_name(inputs)
	if (locale === "es") return es_jw_tool_name(inputs)
	if (locale === "de") return de_jw_tool_name(inputs)
	if (locale === "nl") return nl_jw_tool_name(inputs)
	if (locale === "fr") return fr_jw_tool_name(inputs)
	if (locale === "it") return it_jw_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_jw_tool_name(inputs)
	if (locale === "pt") return pt_jw_tool_name(inputs)
	if (locale === "ja") return ja_jw_tool_name(inputs)
	return zh_jw_tool_name(inputs)
};